import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { Tabs, Tab } from "@material-ui/core";
import { pDialogVersusMachine, pStatus } from "../../utils/parameters";
import Paper from "@mui/material/Paper";
import { useHistory } from "react-router-dom";
import DialogHeader from "../signDialog_content_views/DialogHeader";
import DialogTitle from '@mui/material/DialogTitle';
import DialogDetail from "./DialogDetail";
import DialogResume from "./DialogResume";
import { Button } from '@mui/material';
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";




import "../../styles/devices/mob_VersusMachine.css";
import DialogRanking from "./DialogRanking";

export function VersusMachineDialog(props) {
  const { openDialog, setOpenDialog, elements_requested, elements_response, server_report_activity, returnMenuVersusMachine} = props;
  const { t } = useTranslation("global")

  const [tabValue, setTabValue] = useState(pDialogVersusMachine.resumeTab);
  const [ showOnlyRanking, setShowOnlyRanking ] = useState(false);

  /* Update first time */
  useEffect(() => {
    setTabValue(pDialogVersusMachine.resumeTab)
    if (server_report_activity['personal_score'] !== undefined) {
      if (elements_response.duration === 0){
        setShowOnlyRanking(true)
      }else{
        setShowOnlyRanking(false)
      }
    }
  }, [server_report_activity]);

  /* Close dialog */
  function handleClickClose() {
    /* Dialog settings */
    setOpenDialog(false);
    setTabValue(pDialogVersusMachine.resumeTab);
    returnMenuVersusMachine();
  }

  return (
    <Dialog className="sig_SignModal_Dialog" open={openDialog} onClose={handleClickClose} maxWidth="md">
          
          {showOnlyRanking === false ? 
          <>
            <Paper square className="sig_SignModal_TabsPaper">
              <Tabs
                className="sig_SignModal_Tabs"
                value={tabValue}
                onChange={(event, newValue) => {
                  // console.log('newValue', newValue)
                  setTabValue(newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                <Tab className="sig_SignModal_Tab sig_VSResults_Tab" label={t("sVersusMachine.resumeTab").toUpperCase()} />
                <Tab className="sig_SignModal_Tab sig_VSResults_Tab" label={t("sVersusMachine.detailTab").toUpperCase()} />
                <Tab className="sig_SignModal_Tab sig_VSResults_Tab" label={t("sVersusMachine.rankingTab").toUpperCase()} />
              </Tabs>
            </Paper>

            <DialogContent className="sig_SignModal_DialogContent sig_VersusMachine_DialogContent">

              {tabValue === pDialogVersusMachine.resumeTab ? <DialogResume elements_requested={elements_requested} elements_response={elements_response} /> : <></>}

              {tabValue === pDialogVersusMachine.detailTab ? <DialogDetail elements_requested={elements_requested} elements_response={elements_response} /> : <></>}

              {tabValue === pDialogVersusMachine.rankingTab ? <DialogRanking elements_requested={elements_requested} elements_response={elements_response} server_report_activity={server_report_activity}/> : <></>}
            
            </DialogContent>

            <DialogActions className="sig_FormDialog_Button">
              <Button onClick={handleClickClose}> {t("strButton.btn_exit")} </Button>
            </DialogActions>
            
          
          </> 
          : 
          <>
            <DialogTitle className='sig_Drawer_SettingsModal_Title' > {t("sVersusMachine.rankingTab")} </DialogTitle>

            <DialogContent className="sig_SignModal_DialogContent">

              <DialogRanking elements_requested={elements_requested} elements_response={elements_response} server_report_activity={server_report_activity}/>

            </DialogContent>

            <DialogActions className="sig_FormDialog_Button">
              <Button onClick={handleClickClose}> {t("strButton.btn_exit")} </Button>
            </DialogActions>
          </>
          }
    </Dialog>
  );
}

